import classNames from 'classnames';
import { useTrackVisibility } from 'yoso';
import styles from './FoggyBox.module.scss';

export type FoggyBoxProps = React.PropsWithChildren<{
  className?: string;
}>;
export const FoggyBox = ({ children, className }: FoggyBoxProps) => {
  const [ref, { isVisible }] = useTrackVisibility();
  const isFoggy = !isVisible;

  return (
    <div className={classNames(styles.root, className)}>
      <div className={styles.scrollable}>
        {children}
        <div ref={ref} className={styles.fogTrigger} />
      </div>
      <div className={classNames(styles.foggyArea, { [styles.foggyAreaVisible]: isFoggy })} />
    </div>
  );
};
